import React from 'react';

export const BriefcaseIcon = (props: JSX.IntrinsicElements['svg']) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M.333 4.001h15.334v10.667H.333V4zM5.667 4V2.667A1.337 1.337 0 017 1.333h2a1.337 1.337 0 011.333 1.334V4M8 7.335v-.667"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9 7.333H7.645a.895.895 0 00-.334 1.725l1.376.55a.895.895 0 01-.333 1.725H7M8 12.001v-.666"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
